module.exports = __webpack_public_path__ + "img/fu-poster-bg.2d98cd89.png";